export const getPassioFoodDisplayName = (food) => food.scoredName || food.foodName || food.displayName || "";
export const normalizePassioSearchResultFromRest = (result) => ({
    refCode: result.refCode,
    resultId: result.resultId,
    foodName: result.displayName || result.longName || result.shortName,
    scoredName: result.scoredName,
    brandName: result.brandName,
    iconID: result.iconId,
    type: result.type || result.itemType,
    originSource: result.origin?.[0]?.source,
});
export const normalizePassioSearchResultsFromRest = (payload) => ({
    results: (payload.results ?? []).map(normalizePassioSearchResultFromRest),
    alternatives: payload.alternateNames,
    alternateNames: payload.alternateNames,
});
//# sourceMappingURL=types.js.map